/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { LedgerItem } from './LedgerItem.js';
import {
    LedgerItemFromJSON,
    LedgerItemFromJSONTyped,
    LedgerItemToJSON,
} from './LedgerItem.js';

/**
 * 
 * @export
 * @interface RuleResult
 */
export interface RuleResult {
    /**
     * 
     * @type {number}
     * @memberof RuleResult
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleResult
     */
    points?: number;
    /**
     * 
     * @type {Array<LedgerItem>}
     * @memberof RuleResult
     */
    ledger?: Array<LedgerItem>;
    /**
     * 
     * @type {string}
     * @memberof RuleResult
     */
    notes?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleResult
     */
    flags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RuleResult
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleResult
     */
    disableReason?: string;
}

/**
 * Check if a given object implements the RuleResult interface.
 */
export function instanceOfRuleResult(value: object): boolean {
    return true;
}

export function RuleResultFromJSON(json: any): RuleResult {
    return RuleResultFromJSONTyped(json, false);
}

export function RuleResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleResult {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'points': json['points'] == null ? undefined : json['points'],
        'ledger': json['ledger'] == null ? undefined : ((json['ledger'] as Array<any>).map(LedgerItemFromJSON)),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'flags': json['flags'] == null ? undefined : json['flags'],
        'isDisabled': json['isDisabled'] == null ? undefined : json['isDisabled'],
        'disableReason': json['disableReason'] == null ? undefined : json['disableReason'],
    };
}

export function RuleResultToJSON(value?: RuleResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'points': value['points'],
        'ledger': value['ledger'] == null ? undefined : ((value['ledger'] as Array<any>).map(LedgerItemToJSON)),
        'notes': value['notes'],
        'flags': value['flags'],
        'isDisabled': value['isDisabled'],
        'disableReason': value['disableReason'],
    };
}

